// extracted by mini-css-extract-plugin
module.exports = {"root":"TopbarBlank_root__1Ovr1","container":"TopbarBlank_container__MtD8K","logoLinkDesktop":"TopbarBlank_logoLinkDesktop__S1t7Y","logo":"TopbarBlank_logo__2kxga"};